import { createRouter, createWebHistory } from "vue-router";
import { useCounterStore } from "@/store/index.js";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      name: "Landing",
      path: "/",
      component: () => import("@/views/LandingPage/index"),
      children: [
        {
          name: "home",
          path: "",
          component: () => import("@/views/LandingPage/home"),
        },
        {
          name: "",
          path: "travelDetailsHome/:id",
          props: true,
          component: () => import("@/views/LandingPage/travelDetailsHome"),
        },
        {
          name: "login",
          path: "login",
          component: () => import("@/views/LandingPage/login"),
        },
        {
          name: "register",
          path: "register",
          component: () => import("@/views/LandingPage/register"),
        },
      ],
    },
    {
      beforeEnter: (to, from, next) => {
        const store = useCounterStore();
        if (store.userData && store.userData.stsTokenManager.accessToken) {
          next();
        } else {
          next({
            name: "login",
          });
        }
      },
      name: "dashboard",
      path: "/dashboard",
      component: () => import("@/views/dashboard/index"),
      children: [
        {
          name: "كل الرحلات",
          path: "allTravelsPage",
          component: () => import("@/views/dashboard/allTravelsPage"),
        },
        {
          name: "معاينة الرحلة ",
          path: "travelDetails/:id",
          props: true,
          component: () => import("@/views/dashboard/travelDetails"),
        },
        {
          name: "رحلاتي",
          path: "myTravelPage",
          component: () => import("@/views/dashboard/myTravelPage"),
        },
        {
          name: "اضافة رحلة",
          path: "addTravel",
          component: () => import("@/views/dashboard/addTravel"),
        },
       
      ],
    },

    {
      path: "/:catchAll(.*)",
      name: "error",
      component: () => import("@/views/Pages/index"),
      children: [
        {
          name: "404 Error",
          path: "",
          component: () => import("@/views/Pages/errorPage"),
        },
      ],
    },
  ],
});

export default router;
